module.exports = __webpack_public_path__ + "static/horus_04-ef4869aaa2106081887a05169796f469.jpg";